export default {
      id: "ic_menu_chance_games-usage",
      viewBox: "0 0 50 30",
      url: "/" + "images/icons.3.109.2.svg#ic_menu_chance_games-usage",
      toString: function () {
        return this.url;
      }
    }